export default theme => ({
    root: {
        position: 'relative',
        backgroundColor: '#f2f2f2',
        display: 'flex',
        //height: 36,
        color: theme.palette.default.text,
    },

    focus: {
        '& > span': {
            height: 2,
            width: '100%',
            backgroundColor: '#f2f2f2',
            position: 'absolute',
            bottom: -1,
            content: "' '",
            animation: 'expand 280ms',
            transformOrigin: 'center'
        }
    },

    input: {
        flex: 1,
        padding: '18.5px 14px',
        height: '1.1875em',
        margin: 0,
        border: 'none',
        outline: 'none',
        fontSize: 14,
        backgroundColor: '#f2f2f2',
    },

    label: {
        position: 'absolute',
        fontSize: 14,
        left: 0,
        bottom: 10,
        padding: 0,
        cursor: 'text',
        transform: 'translateY(0) scale(1)',
        animation: 'collapse 200ms',
        color: theme.palette.default.text,
        userSelect: 'none',
    },

    '@keyframes retract': {
        from: {
            transform: 'translateY(0) scale(1)',
            left: 0,
        },
        to: {
            transform: 'translateY(-20px) scale(.85)',
            left: -4
        }
    },
    '@keyframes collapse': {
        from: {
            transform: 'translateY(-20px) scale(.85)',
            left: -4
        },
        to: {
            transform: 'translateY(0) scale(1)',
            left: 0
        }
    },
    '@keyframes expand': {
        from: {
            transform: 'scale(0)',
        },
        to: {
            transform: 'scale(1)'
        },
    }
})
